import { useEffect, useState } from "react";
import { motionAllowed } from "../../lib/motion.js";
import { PixelArt } from "../pixel-art/pixel-art.js";
import { UPDATES } from "./updates.js";
import { useWhatsNew } from "./whats-new.js";

/** How long each update's picture stays in the thumbnail. */
const TURN_MS = 4200;

/**
 * The rail's way into What's new (DESIGN.md §5): a living thumbnail, the
 * name, and a dot while anything is unseen — one line.
 */
export function WhatsNewCard() {
  const news = useWhatsNew();
  const turn = useTurning(UPDATES.length);
  if (news?.newest === undefined) return null;
  const shown = UPDATES[turn] ?? news.newest;
  return (
    <button
      type="button"
      className="side-news"
      aria-haspopup="dialog"
      onClick={news.open}
    >
      <PixelArt
        variant={shown.art.variant}
        scene={shown.art.scene}
        columns={9}
        className="side-news-thumb"
      />
      <span className="side-news-title">
        What&apos;s new
        {news.unseen > 0 ? (
          <span className="visually-hidden">, {String(news.unseen)} new</span>
        ) : null}
      </span>
      {news.unseen > 0 ? <span className="side-news-dot" aria-hidden="true" /> : null}
    </button>
  );
}

/** Which update the thumbnail shows, moving on every few seconds while the tab is seen. */
function useTurning(count: number): number {
  const [turn, setTurn] = useState(0);
  // A timer, not data. Under reduced motion the thumbnail keeps its first picture.
  useEffect(() => {
    if (count < 2 || !motionAllowed()) return undefined;
    const timer = window.setInterval(() => {
      if (!document.hidden) setTurn((was) => (was + 1) % count);
    }, TURN_MS);
    return () => {
      window.clearInterval(timer);
    };
  }, [count]);
  return turn;
}
